import { useState } from "react";
import styles from "../SolarProvider.module.scss";
import { SolarProviderOrderModel } from "../../../../model/orders/orders";
import { formatDate } from "../../../../utils";
import OrderDetailSideDialog from "./OrderDetailsSideDailog";

export interface SolarProviderProps {
	orders?: Array<SolarProviderOrderModel>;
}

const SolarProviderOrder: React.FC<SolarProviderProps> = ({ orders }) => {
	const [selectedOrder, setSelectedOder] = useState<string>("");

	return (
		<>
			{selectedOrder && <OrderDetailSideDialog orderId={selectedOrder} handleCloseDialog={() => setSelectedOder("")} />}
			<div className={styles.tableContainer}>
				<table className="standardTable">
					<thead>
						<tr>
							<th>CUSTOMER NAME</th>
							<th>PRODUCT ORDERED</th>
							<th>PAYMENT DATE</th>
							<th>ORDER STATUS</th>
							<th>DATE STAUS CHANGED</th>
							<th>VIEW DETAILS</th>
						</tr>
					</thead>
					<tbody>
						{orders?.map(order => {
							return (
								<tr key={order?.id}>
									<td>{order?.customerName}</td>
									<td>{order?.name}</td>
									<td>{formatDate(order?.paymentDate ?? "")}</td>
									<td>{order.status}</td>
									<td>{formatDate(order?.statusChanged)}</td>
									<td>
										<button className={`actionButton`} onClick={() => setSelectedOder(order?.id)}>
											VIEW DETAILS
										</button>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		</>
	);
};

export default SolarProviderOrder;
